import React from "react";

const Title = ({ text }) => {
  return (
    <header className='flex items-center w-full p-4'>
      <div className="flex items-center">
        <article className='flex flex-col'>
          <div className='flex items-center'>
            <img
              alt="a vertical divider"
              src='./../assets/icons/divider-vertical.svg'
              className='h-7 mr-2'
            />
            <h1 className='text-2xl font-bold'>{text}</h1>
          </div>
        </article>
      </div>
    </header>
  );
};

export default Title;